<template>
  <div>
    <a-list
      :bordered="bordered"
      item-layout="vertical"
      size="large"
      :loading="loading"
      :pagination="pagination"
      :data-source="productListData"
    >
      <a-list-item slot="renderItem" key="item.scr" slot-scope="item">
        <div class="certificateListBox acea-row">
          <div class="right_box row-center-wrapper acea-row row-column">
            <div
              :style="`backgroundImage: url(` + item.productImg + `)`"
              class="productImg"
            ></div>
            <div class="name">{{ item.name }}</div>
            <div class="size">外型尺寸(HxWxDmm)</div>
            <div class="size">{{ item.size }}</div>
          </div>
          <div class="left_box row-center-wrapper acea-row row-column">
            <div class="title">{{ item.name }}技术参数表</div>
            <div class="acea-row table_big_column">
              <!-- <div
              :style="`backgroundImage: url(` + item.paramsImg + `)`"
              class="paramsImg"
            ></div> -->
            <img  :src="item.paramsminiImg" class="paramsminiImg" />
            <img  class="paramsImg" :style="{width:'600px',height:item.name=='PSD16-SF/W1' || item.name=='PS-JC'?'400px':'280px'}" :src="item.paramsImg"/>
              <!-- <div  class="table_box_right">
                <div
                :style="{borderBottom:item.tableDataRight.length-1==indexT?'none':''}"
                  v-for="(itemT, indexT) in item.tableDataRight"
                  :key="indexT"
                  class="tr_box acea-row"
                >
                  <div class="td_tit">{{ itemT.technicalIndicators }}</div>
                  <div class="td_con">{{ itemT.performanceDesc }}</div>
                </div>
              </div>
              <div class="table_box_left">
                <div
                :style="{borderBottom:item.tableDataLeft.length-1==indexT?'none':''}"
                  v-for="(itemT, indexT) in item.tableDataLeft"
                  :key="indexT"
                  class="tr_box acea-row"
                >
                  <div class="td_tit">{{ itemT.technicalIndicators }}</div>
                  <div class="td_con">{{ itemT.performanceDesc }}</div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </a-list-item>
    </a-list>
  </div>
</template>
<script>
export default {
  props: ["productList"],
  data() {
    return {
      // isBorderBottomSty:"",
      loading: true,
      bordered: false,
      pagination: {
        onChange: (page) => {
          console.log(page, "ff");
          this.nowPage = page;
        },
        position: "bottom",
        pageSize: 3,
      },
      nowPage: 1,
      productListData: [],
    };
  },
  created: function () {
    this.productListData = this.productList;
    this.loading = false;
  },
  mounted: function () {
    console.log("this1", this.productList);
  },
};
</script>
<style scoped>
.certificateListBox {
  width: 100%;
  background-color: #fff;
  padding: 30px 60px;
  box-shadow: 0 0 10px 0px rgba(115, 115, 116, 0.5);
  border-radius: 15px;
}
.certificateListBox .right_box{
  margin-right: 40px;
}
.certificateListBox .right_box .productImg {
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 260px;
  height: 220px;
  margin: 30px;
}
.certificateListBox .right_box .name {
  font-size: 22px;
  color: #555555;
}
.certificateListBox .right_box .size {
  font-size: 18px;
  color: #777777;
  margin-top: 10px;
}

.certificateListBox .left_box .paramsImg {
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 700px;
  height: 360px;
  margin: 30px;
}
.certificateListBox .left_box .paramsminiImg {
  width: 100%;
  height: 100%;
  display: none;
}
 .certificateListBox .left_box .title{
   margin-bottom: 30px;
   color: #555555;
   font-size: 22px;
 }
/* 去除边框 */
.ant-list-something-after-last-item
  .ant-spin-container
  > .ant-list-items
  > .ant-list-item:last-child {
  border: none;
}
.ant-list-split .ant-list-item {
  border: none;
}
.table_box_right {
  border: solid 1px black;
  border-right: none;
}
.table_box_left {
  border: solid 1px black;
}
.tr_box {
  flex-wrap: nowrap;
  border-bottom: solid 1px black;
}
.tr_box .td_tit {
  padding: 0px 7px;
  text-align: left;
  padding: 5px;
  background-color: #f3f3f3;
  font-size: 18px;
  width: 180px;
}
.tr_box .td_con {
  padding: 0px 7px;
  text-align: left;
  padding: 5px;
  font-size: 18px;
  width: 340px;
}
/* 底部分页位置 */
.ant-list-pagination {
  margin-top: 24px;
  text-align: center;
}
@media screen and (max-width: 850px) {
  .certificateListBox {
    flex-direction: column;
    background-color: #f3f3f3;
    box-shadow: none;
  }
  .certificateListBox .left_box .paramsImg {
     display: none;
  }
  .certificateListBox .left_box .paramsminiImg{
    display: block;
  }
  .certificateListBox .right_box .productImg {
    width: 420px;
    height: 400px;
  }
  .certificateListBox .right_box .name {
    font-size: 30px;
    font-weight: bolder;
  }
  .certificateListBox .left_box .title {
    font-size: 25px;
    font-weight: bolder;
    margin: 50px 0px 30px 0px;
    color: black;
  }
  .table_big_column {
    flex-direction: column;
  }
  .table_box_right{
    border: solid 1px black;
  }
  .table_box_left{
    border-top: none;
  }
  .tr_box .td_tit {
    width: 300px;
    padding: 10px;
  }
  .tr_box .td_con{
     width: 300px;
     padding: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/productList2/index.vue